import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function ModalPortal({ children }) {
  const hostRef = useRef(null);
  if (!hostRef.current) hostRef.current = document.createElement('div');

  useEffect(() => {
    const host = hostRef.current;
    document.body.appendChild(host);
    return () => document.body.removeChild(host);
  }, []);

  return createPortal(children, hostRef.current);
}
